{
  "AgentOmnichannel_AllowAnsweringConcurrent": "Beantwortung gleichzeitiger Kanäle zulassen:",
  "AgentOmnichannel_Chat_IntegrationType": "Chat-Integration Typ:",
  "AgentOmnichannel_Chat_IDOnChatSystem": "ID im Chat-System:",
  "AgentOmnichannel_Chat_LiveChatAgentID": "Livechat Agent ID:",
  "AgentOmnichannel_Email_IntegrationType": "E-Mail-Integration Typ:",
  "AgentOmnichannel_Email_EmailAddress": "E-Mail Adresse:",
  "AgentOmnichannel_Email_IDOnEmailSystem": "ID im E-Mail-System:",
  "AgentOmnichannel_Chat_IntegrationTypes_None": "[Keine]",
  "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",
  "AgentOmnichannel_Email_IntegrationTypes_None": "[Keine]",
  "AgentOmnichannel_Email_IntegrationTypes_Pop3": "E-Mail (POP3 und SMTP)",
  "AgentOmnichannel_Email_EmailAddress_Invalid": "E-Mail Adresse ist ungültig",
  "NAME": "AgentOmnichannel"
}